import React, { useEffect } from 'react';
import './EtchEndCap.scss';

const EtchEndCap = (props) => {

  useEffect(() => {
    const initTopDealsWidget = async () => {
      const { default: TopDealsWidget } = await import(/* webpackChunkName: "top-deals-widget" */ 'thd-events-widgets/dist/top-deals-widget.es6.umd');
      TopDealsWidget.init();
    }
    initTopDealsWidget();
  }, []);
  const opts = props?.opts || {};
  const { id } = opts;

  return (
    <div className="etch-analytics" data-module-id={id} id="top-deals__wrapper" />
  );
};

export default EtchEndCap;
